import { createSlice } from '@reduxjs/toolkit'

const changeEmailSlice = createSlice({
  name: 'changeEmail',
  initialState: {
    newEmail: '',
  },
  reducers: {
    setNewEmail: (state, action) => {
      state.newEmail = action.payload
    },
  },
})

export const { setNewEmail } = changeEmailSlice.actions

export default changeEmailSlice.reducer
